var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('no-internet-connection'),_c('notifications-wrapper'),(_vm.$store.state.application.loading)?_c('loading'):_c('router-view'),_c('expired-session')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }